import apiAddress from '@/api/member/address';

const defaultState = () => ({
	addressData: [],
	loadAddress: false,
	detailAddress: {},
	addressPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setAddress(state, data) {
		state.addressData = data.data
		state.addressPagination = data.pagination;
	},
	setloadAddress(state, data) {
		state.loadAddress = data
	},
	setAddressDetail(state, data) {
		state.detailAddress = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearAddress(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getAddress({ commit }, params) {
		commit('setloadAddress', true);
		return new Promise((resolve) => {
			apiAddress.getAddress(params).then(({ data: { data } }) => {
				commit('setAddress', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setAddress', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadAddress', false);
			});
		});
	},
	getAddressDetail({ commit }, params) {
		commit('setloadAddress', true);
		return new Promise((resolve) => {
			apiAddress.getAddressDetail(params).then(({ data: { data } }) => {
				commit('setAddressDetail',data.results);
				resolve(true);
			}).catch(() => {
				commit('setAddressDetail', {});
			}).then(() => {
				commit('setloadAddress', false);
			});
		});
	},
	addAddress({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiAddress.addAddress(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	updateAddress({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiAddress.updateAddress(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	removeAddress({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiAddress.removeAddress(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	setDefaultAddress({ dispatch, commit}, params) {
		return new Promise((resolve, reject) => {
			apiAddress.setDefaultAddress(params).then(({ data }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: data.message, show: true }, { root: true });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	success({commit}, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};